module.exports = __webpack_public_path__ + "static/media/silver-coin.3c288342.png";